import { useMemo } from 'react';

import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';

import { type AppDispatch, type RootState } from './store';

export type AppParams = {
  appDefId: string;
  instanceId: string;
};

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
export const useParametricSelector = <Param, Result>(
  selectorCreator: () => (state: RootState, param: Param) => Result,
  param: Param,
) => {
  const selector = useMemo(selectorCreator, [selectorCreator]);
  return useAppSelector((state) => selector(state, param));
};
